import React from 'react';
import dbTecnologias from '../db/tecnologias';
import TecnologiasCards from './TecnologiasCards';


export function Tecnologias() {
    return (
     <div className="flex flex-1 flex-col bg-gray-600 py-10 md:py-14 lg:py-16">
      <div className="mx-auto grid w-full max-w-screen-2xl flex-1 grid-cols-2 content-start justify-items-center gap-x-4 gap-y-8 px-4 sm:grid-cols-4 sm:gap-x-8 sm:gap-y-11 sm:px-6 md:grid-cols-6 md:gap-y-12 lg:min-h-[min(52vh,560px)] lg:content-evenly lg:gap-x-10 lg:gap-y-14 lg:px-8">
          {dbTecnologias.map((value) => (
          <TecnologiasCards
            key={ value.name }
            name={ value.name }
            image={ value.image }
          />
        ))}  
      </div>
    </div>
    )  
}

export default Tecnologias
